<template>
  <div class="studentsList">
    <el-card>
      <!-- 添加按钮 -->
      <div style="text-align:left;width:100%;height:50px;line-height:50px;">
        <div style="float: left;font-size: 18px;">{{eventStr}}</div>
        <div style="float: right;"><el-button class="addStudent " type="primary" @click="resetScore" style="font-size: 15px;">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14.329" height="14" viewBox="0 0 12.329 9"><image id="复原" width="12.329" height="9" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABJCAYAAADL0IO8AAAABHNCSVQICAgIfAhkiAAABYFJREFUeF7tnL1rFEEYxj1EC0XUSizUS6eVRgULCy+toiZV0MYLGFAEjQhaqJiAH/iBRLARBC+tjYnae9eLJpWll7/AWGl3Ps8yG/eSvZt3ZnbPvfMdeMkmmXln9vndO5+7V9qgqVAKlPJsTavV2gz/U7A7sO+wY6VS6Xeedfa771yAAAT9noc9hO1NiDQOIG/7XbQ82585EMA4gQbPwg6lNPwSgLzK84b63XdmQADiAMR4BjvZRRQFYvnEBAMBiF2o4z5sArbRUp8CyQsIQGyF75uwGzBeS5ICyRoIQDAKLsJmYIwOl6RAsgQCGKfh7zGM44VP+ohCn30K9rjMCupbNHUuYSLC33uSRGMIQHDG9BJ2vCetKmYlhDJvrJEXpK5AAGIPGvAENg4TwSumlrm0inDqsAXAaWZVQ6rIALENFXDmdBm2KavKBtgP110zWURNJyDvUQHHC01yBdilzQIKJzveqROQr/CYttL2rug/Ksjuaxpg5nzuuROQg3BGh/ypyU+BGqBwseyUOg7UZoPwHLw9gJWdvGrmWIE6LsZcxhbrzMlsoV+F49uwHaq1swJcz0wASryu6erACiQuDTA7cX0XdgXGcw5NcgU44DNSGDHZAEmAYff1COazNnmOch9sjfrH/2cvEE9oeK80HimEJkIZsUWKOELWtgYRcxR/4/zbZfXet3tZuN9R3CutAtvnSYdQhrqNKd5AEhFzBtfc39ovaGTfAkneG+BUzYdxu+Ce12ZZBJDhTuWCgdCx2QGexOU0rNsO8EAAMffMro3PC9BcwXScEmcCJBEtPBe5BeMZyZaUT8HAAEncM8ebGsx1zXYdkcIuvy1lCiTRyN24jk8Rk3VMohGvPcK80EXQQzBa6h5QOJ40kzeXC5AEGJ6bPIWdMn87ggZ8KbS6AY0DGEbKBQcXc9Cj2jMgCTCHcf0LlX9zaGxfZgUUbsufdWh8W5TkGiEOjRqYrB7dVx0f1JFYAAWSw0cBUMpwy60S6eyLC0aOQXoKmAOPyCWgVPDjk9A/Tx256FQgQsG8sgEKP/WibRcAiXor7bK8pJYVcowSbj7OKxCZtt65HGZd0RRYgXhLLSvoECVNABlSIDJdg3IBCnd5JTOuYQUSJLWssMMKfkaByDQNymW2698InCgQgUjBWcxCka/02dKcRohNooz+DygtgauGAhGolEUWBZKFihn6ABDubdkOsVY0QjIUvZsr6TaKAlEgPVKgYNXoGKJACqZAgZpjThF/CJq0oGOIQKXQLOapx3cCP7pSF4gUnAVA+PzVNYEjBSIQKTgLgHDbpCxwNKZdlkClkCwO+1gbeIyrQELUFpQFkGlkuyfIGj3ooEAESvlmMbMrdleSN8/4llVNgfiqLSjncDBFb9ETjApEIKxPFpexA/75fSrRW1sKxEdtQRkAcXnXP+quFIhAWJ8sgMHj2qqw7DJgrE6JNUKEqkmzOZyfxy5Xo0MjRKqyMJ8HjAaio5J0rxEiFNuWDTC4NbLuFTVLudWn3uN8CsSmtOD/jmNG7HH1iXeNEIHIkiwAwakqB3DXb05aQpkKuis+0diWNEIkyq/JY9YY3A6pehT/SYBcBKaVVSAOigIE3x3kIMx3033TunFDuyyLlCYC4q/PYHdECDTJnlQ3721T3NQIMVM1hl/ZF7mWEynwAt2UNbJKDocnolo1U6oC1siISxGI5JlT1dlPAQ7go/EbthIXCkSikl8eTm2rgCH6JjmNED+RpaUWDIx16wybA40Qm0Ju/28gO78itu5W7G9uBeKrXHu5Zfw6xdeaQ90pkDAFGRH8MrJamJv2CJG8t5BVff3uh7MmRgG7pPm0vajQG2SEVBhusNBVaGhbila+iQbRmKIxIWRskN7cH3D8ounr7hUhAAAAAElFTkSuQmCC"/></svg>&nbsp;复原</el-button></div>
      </div>
      <hr>
      <!-- 试题列表 -->
      <div>
        <div v-for="(item,index) in dataList" class="examList">
          <div ><span>{{ index + 1 }}. </span><span v-html="item.question"></span></div>
          <div >学生答案：
            <span v-if="item.flag == 0" class="error-font">
              <svg xmlns="http://www.w3.org/2000/svg" width="11.536" height="11.536" viewBox="0 0 11.536 11.536">
                <g id="组_1036" data-name="组 1036" transform="translate(1.768 1.768)">
                  <g id="组_1035" data-name="组 1035">
                    <line id="直线_55" data-name="直线 55" x2="8" y2="8" fill="none" stroke="#aa060d" stroke-linecap="round" stroke-width="2.5"/>
                    <line id="直线_56" data-name="直线 56" y1="8" x2="8" fill="none" stroke="#aa060d" stroke-linecap="round" stroke-width="2.5"/>
                  </g>
                </g>
              </svg>
              {{item.nixuande}}
            </span>
            <span v-else>
              <svg xmlns="http://www.w3.org/2000/svg" width="15.535" height="11.017" viewBox="0 0 15.535 11.017">
                <path id="路径_219" data-name="路径 219" d="M10241.014,5297.768l4.308,4.48,7.692-8" transform="translate(-10239.246 -5292.48)" fill="none" stroke="#006a11" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"/>
              </svg>
              {{item.nixuande}}
            </span>
          </div>
          <div v-if="item.flag == 0">正确答案：{{item.right_answer}}</div>
        </div>
      </div>
    </el-card>
    <!-- 弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <span>是否确认复原测试？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleOK">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
// 引入学生列表表格组件
import ExamsList from "@/assets/js/teacher/calendar/ExamsList.js";
export default {
  ...ExamsList
}
</script>
<style lang="scss">
.studentsList {
  .el-dialog {
    width: 27.5rem !important;
    border-radius: 12px !important;
  }
  .el-dialog__title {
    font: normal normal normal 1.125rem Source Han Sans CN;
  }
  .el-dialog__headerbtn {
    font-size: 1.4375rem;
  }
  .opt-dialog{
    .el-dialog{
      width: 62.5rem !important;
      height: 40rem !important;
      .el-table{
        height: 50vh !important;
      }
    }
  }
}
</style>
<style lang='scss' scoped >
@import "@/assets/css/teacher/calendar/ExamsList.scss";
</style>